import React from "react";
import { ReactComponent as ArrowDown } from "../../assets/icons/arrow-down.svg";
import { ReactComponent as ArrowLeft } from "../../assets/icons/arrow-left.svg";
import { ReactComponent as ArrowRight } from "../../assets/icons/arrow-right.svg";
import { ReactComponent as ArrowUp } from "../../assets/icons/arrow-up.svg";
import { ReactComponent as ArrowDownLine } from "../../assets/icons/arrow-down-line.svg";
import { ReactComponent as ArrowLeftLine } from "../../assets/icons/arrow-left-line.svg";
import { ReactComponent as ArrowRightLine } from "../../assets/icons/arrow-right-line.svg";
import { ReactComponent as ArrowUpLine } from "../../assets/icons/arrow-up-line.svg";
import { ReactComponent as Bag } from "../../assets/icons/bag.svg";
import { ReactComponent as Basket } from "../../assets/icons/basket.svg";
import { ReactComponent as Bookmark } from "../../assets/icons/bookmark.svg";
import { ReactComponent as BurgerMenu } from "../../assets/icons/burger-menu.svg";
import { ReactComponent as Calendar } from "../../assets/icons/calendar.svg";
import { ReactComponent as Checkmark } from "../../assets/icons/checkmark.svg";
import { ReactComponent as Close } from "../../assets/icons/close.svg";
import { ReactComponent as Document } from "../../assets/icons/document.svg";
import { ReactComponent as Download } from "../../assets/icons/download.svg";
import { ReactComponent as Edit } from "../../assets/icons/edit.svg";
import { ReactComponent as Facebook } from "../../assets/icons/facebook.svg";
import { ReactComponent as FavoritFull } from "../../assets/icons/favorit-full.svg";
import { ReactComponent as FavoritStroke } from "../../assets/icons/favorit-stroke.svg";
import { ReactComponent as Filter } from "../../assets/icons/filter.svg";
import { ReactComponent as FullScreen } from "../../assets/icons/full-screen.svg";
import { ReactComponent as Globe } from "../../assets/icons/globe.svg";
import { ReactComponent as Hide } from "../../assets/icons/hide.svg";
import { ReactComponent as Home } from "../../assets/icons/home.svg";
import { ReactComponent as Image } from "../../assets/icons/image.svg";
import { ReactComponent as Instagram } from "../../assets/icons/instagram.svg";
import { ReactComponent as Link } from "../../assets/icons/link.svg";
import { ReactComponent as Linkedin } from "../../assets/icons/linkedin.svg";
import { ReactComponent as Logo } from "../../assets/icons/logo.svg";
import { ReactComponent as Mail } from "../../assets/icons/mail.svg";
import { ReactComponent as MapPin } from "../../assets/icons/map-pin.svg";
import { ReactComponent as Minus } from "../../assets/icons/minus.svg";
import { ReactComponent as Pause } from "../../assets/icons/pause.svg";
import { ReactComponent as Phone } from "../../assets/icons/phone.svg";
import { ReactComponent as Phone2 } from "../../assets/icons/phone2.svg";
import { ReactComponent as PlayFill } from "../../assets/icons/play-fill.svg";
import { ReactComponent as Play } from "../../assets/icons/play.svg";
import { ReactComponent as Plus } from "../../assets/icons/plus.svg";
import { ReactComponent as Print } from "../../assets/icons/print.svg";
import { ReactComponent as Profile } from "../../assets/icons/profile.svg";
import { ReactComponent as Quote } from "../../assets/icons/quote.svg";
import { ReactComponent as SafePayment } from "../../assets/icons/safe-payment.svg";
import { ReactComponent as Search } from "../../assets/icons/search.svg";
import { ReactComponent as Share } from "../../assets/icons/share.svg";
import { ReactComponent as Show } from "../../assets/icons/show.svg";
import { ReactComponent as SmallScreen } from "../../assets/icons/small-screen.svg";
import { ReactComponent as Time } from "../../assets/icons/time.svg";
import { ReactComponent as Trash } from "../../assets/icons/trash.svg";
import { ReactComponent as Twitter } from "../../assets/icons/twitter.svg";
import { ReactComponent as Vimeo } from "../../assets/icons/vimeo.svg";
import { ReactComponent as Weather } from "../../assets/icons/weather.svg";
import { ReactComponent as Youtube } from "../../assets/icons/youtube.svg";
import { ReactComponent as Zoomminus } from "../../assets/icons/zoom-minus.svg";
import { ReactComponent as Zoomplus } from "../../assets/icons/zoom-plus.svg";
import styled, { keyframes } from "styled-components";

interface IconProps
{
    name: string;
    className?: string;
}

const FadeIn = keyframes`
     0% { opacity: 0; transform: scale(0); }
     100% { opacity: 1; transform: scale(1);}
`;

const IconWrap = styled.span`
    display: inline-block;
    svg {
        fill: currentColor;
        stroke: currentColor;
        pointer-events: none;
        animation: ${FadeIn} .15s forwards;
    }
`;

/*
    This is just a temporary solution for icon management.
    Ideally a spritesheet would be preferable so it only makes 1 request,
    but let's see what moving in the frontend world when the times comes.
*/
const Icon = (props: IconProps) =>
{
    switch (props.name)
    {
        case "arrow-left":
            return <IconWrap><ArrowLeft className={props.className} /></IconWrap>;
        case "arrow-down":
            return <IconWrap><ArrowDown className={props.className} /></IconWrap>;
        case "arrow-right":
            return <IconWrap><ArrowRight className={props.className} /></IconWrap>;
        case "arrow-up":
            return <IconWrap><ArrowUp className={props.className} /></IconWrap>;
        case "arrow-left-line":
            return <IconWrap><ArrowLeftLine className={props.className} /></IconWrap>;
        case "arrow-down-line":
            return <IconWrap><ArrowDownLine className={props.className} /></IconWrap>;
        case "arrow-right-line":
            return <IconWrap><ArrowRightLine className={props.className} /></IconWrap>;
        case "arrow-up-line":
            return <IconWrap><ArrowUpLine className={props.className} /></IconWrap>;
        case "bag":
            return <IconWrap><Bag className={props.className} /></IconWrap>;
        case "basket":
            return <IconWrap><Basket className={props.className} /></IconWrap>;
        case "bookmark":
            return <IconWrap><Bookmark className={props.className} /></IconWrap>;
        case "burger-menu":
            return <IconWrap><BurgerMenu className={props.className} /></IconWrap>;
        case "calendar":
            return <IconWrap><Calendar className={props.className} /></IconWrap>;
        case "checkmark":
            return <IconWrap><Checkmark className={props.className} /></IconWrap>;
        case "close":
            return <IconWrap><Close className={props.className} /></IconWrap>;
        case "document":
            return <IconWrap><Document className={props.className} /></IconWrap>;
        case "download":
            return <IconWrap><Download className={props.className} /></IconWrap>;
        case "edit":
            return <IconWrap><Edit className={props.className} /></IconWrap>;
        case "facebook":
            return <IconWrap><Facebook className={props.className} /></IconWrap>;
        case "favorite-full":
            return <IconWrap><FavoritFull className={props.className} /></IconWrap>;
        case "favorite-stroke":
            return <IconWrap><FavoritStroke className={props.className} /></IconWrap>;
        case "filter":
            return <IconWrap><Filter className={props.className} /></IconWrap>;
        case "full-screen":
            return <IconWrap><FullScreen className={props.className} /></IconWrap>;
        case "globe":
            return <IconWrap><Globe className={props.className} /></IconWrap>;
        case "hide":
            return <IconWrap><Hide className={props.className} /></IconWrap>;
        case "home":
            return <IconWrap><Home className={props.className} /></IconWrap>;
        case "image":
            return <IconWrap><Image className={props.className} /></IconWrap>;
        case "instagram":
            return <IconWrap><Instagram className={props.className} /></IconWrap>;
        case "link":
            return <IconWrap><Link className={props.className} /></IconWrap>;
        case "linkedin":
            return <IconWrap><Linkedin className={props.className} /></IconWrap>;
        case "logo":
            return <IconWrap><Logo className={props.className} /></IconWrap>;
        case "mail":
            return <IconWrap><Mail className={props.className} /></IconWrap>;
        case "map-pin":
            return <IconWrap><MapPin className={props.className} /></IconWrap>;
        case "minus":
            return <IconWrap><Minus className={props.className} /></IconWrap>;
        case "pause":
            return <IconWrap><Pause className={props.className} /></IconWrap>;
        case "phone":
            return <IconWrap><Phone className={props.className} /></IconWrap>;
        case "phone2":
            return <IconWrap><Phone2 className={props.className} /></IconWrap>;
        case "play":
            return <IconWrap><Play className={props.className} /></IconWrap>;
        case "play-fill":
            return <IconWrap><PlayFill className={props.className} /></IconWrap>;
        case "plus":
            return <IconWrap><Plus className={props.className} /></IconWrap>;
        case "print":
            return <IconWrap><Print className={props.className} /></IconWrap>;
        case "profile":
            return <IconWrap><Profile className={props.className} /></IconWrap>;
        case "quote":
            return <IconWrap><Quote className={props.className} /></IconWrap>;
        case "safe-payment":
            return <IconWrap><SafePayment className={props.className} /></IconWrap>;
        case "search":
            return <IconWrap><Search className={props.className} /></IconWrap>;
        case "share":
            return <IconWrap><Share className={props.className} /></IconWrap>;
        case "show":
            return <IconWrap><Show className={props.className} /></IconWrap>;
        case "small-screen":
            return <IconWrap><SmallScreen className={props.className} /></IconWrap>;
        case "time":
            return <IconWrap><Time className={props.className} /></IconWrap>;
        case "trash":
            return <IconWrap><Trash className={props.className} /></IconWrap>;
        case "twitter":
            return <IconWrap><Twitter className={props.className} /></IconWrap>;
        case "vimeo":
            return <IconWrap><Vimeo className={props.className} /></IconWrap>;
        case "weather":
            return <IconWrap><Weather className={props.className} /></IconWrap>;
        case "youtube":
            return <IconWrap><Youtube className={props.className} /></IconWrap>;
        case "zoom-minus":
            return <IconWrap><Zoomminus className={props.className} /></IconWrap>;
        case "zoom-plus":
            return <IconWrap><Zoomplus className={props.className} /></IconWrap>;
    }
    return null;
};

export default Icon;